import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_ORDERS, GET_ORDERS_BY_ID } from "../graphql/Query/Order.js";
import { GET_ROLE_USER } from "../graphql/Query/Signin.js";
import SpinLoader from "../components/SpinLoader.js";
import { createRoot } from 'react-dom/client';
import moment from "moment";
import { FiDownload } from 'react-icons/fi';
import { GrDocumentDownload } from "react-icons/gr";
import { MdFileDownload } from "react-icons/md";
import NoDataFound from "../components/NoDataFound.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import { Link } from "react-router-dom";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Invoice from "../Common/Invoice.js";
import CustomLabel from "../Common/CustomLabel.js";
import * as XLSX from 'xlsx';
import CustomPagination from "../components/Pagination.js";
import Loader from "../components/Loader.js";
import { allowedPincodes } from "../OrderPage/PincodeService.js";
import { handleDownload } from "../Common/DownloadLabel.js";
import Table from "../components/Table/index.jsx";
import { orderTableColumns } from "../components/Constant/index.js";

const channelOptions = [
    { value: "All", label: "All Channels" },
    { value: "Custom", label: "Custom" },
];

export const typeOptions = [
    { value: "", label: "All" },
    { value: "cod", label: "COD" },
    { value: "prepaid", label: "Prepaid" },
];

export const warehouseOptions = [
    { value: "", label: "All" },
    { value: "Today", label: "Today" },
    { value: "4 days", label: "Last 4 days" },
    { value: "Last 7 days", label: "Last 7 days" },
    { value: "This Month", label: "This Month" },
    { value: "Last Month", label: "Last Month" },
];

const AllOrderSeller = () => {
    const [toggleCleared, settoggleCleared] = useState(false);
    const [multipleId, setMultipleId] = useState([]);
    const invoiceRef = useRef(null);
    const [activeTab, setActiveTab] = useState("All");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sort, setSort] = useState({ key: "createdAt", type: -1 });
    const [orderData, setOrderData] = useState([]);
    // console.log('✌️orderData --->', orderData);
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    // console.log('✌️orderData --->', orderData);
    const [loadingData, setLoading] = useState(false);
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [fromDate, setFromDate] = useState('');
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'All') {
            setorderStatus('');
        } else if (tab === 'Cancelled') {
            setorderStatus('cancelled');
        } else if (tab === 'Pending Pickup') {
            setorderStatus('pending pickup');
        } else if (tab === 'In Transit') {
            setorderStatus('in transit');
        } else if (tab === 'Out For Delivery') {
            setorderStatus('out for delivery');
        } else if (tab === 'Delivered') {
            setorderStatus('delivered');
        } else if (tab === 'RTO') {
            setorderStatus('rto');
        } else if (tab === 'RTO Delivered') {
            setorderStatus('rto delivered');
        } else if (tab === 'Booked') {
            setorderStatus('booked');
        } else {
            setorderStatus('');
        }
    };
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value
    const [activeButton, setActiveButton] = useState('All Courier');
    const { data: getUser, refetch: getUserRoleRefetch } = useQuery(GET_ROLE_USER);
    const idData = localStorage.getItem('id');
    const [filter, setFilter] = useState('');
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_ORDERS, {
        variables: {
            page: page,
            limit,
            "sort": sort,
            customerId: getUser?.me?.id || idData,
            tag: activeButton,
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            orderStatus: orderStatus,
            paymentStatus: selectedPaymentType,
            dayRange: selectedDayRange
        },
        fetchPolicy: 'cache-and-network',
    });
    const [singleOrder, setSingleOrder] = useState();
    // console.log('✌️singleOrder --->', singleOrder);
    const [singleOrderLabel, setSingleOrderLabel] = useState();
    const [GetOrderOrderData, { loading: loadingDataDownload }] = useLazyQuery(GET_ORDERS_BY_ID, {
        fetchPolicy: "cache-and-network"
    });
    useEffect(() => {
        if (GetOrderOrder?.getOrders?.data) {
            setOrderData(GetOrderOrder?.getOrders?.data);
        }
    }, [GetOrderOrder]);
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }
    const handleClear = () => {
        settoggleCleared(!toggleCleared)
    }


    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index,
                "Order ID": shipment?.order_id,
                "Order Number": shipment?.order_number,
                "Shipment Date": moment(shipment?.createdAt).format('DD/MM/YYYY'),
                AWB: shipment?.awb_number,
                "COD Collectable Rs.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "COD Collection Rs.": `${shipment?.codCollectableValue}`,
                "Shipment Charge": `₹${shipment?.order_amount}`,
                "Payment Type": shipment?.payment_type,
                "Receiver Name (To)": shipment?.deliveryAddress?.name,
                State: state,
                Address: fullAddress,
                City: city,
                "Zip Code": zipCode,
                // "phone":demoo,
                "Weight (Kg)": shipment?.package_weight_Length,
                Status: shipment?.status,
                Product: shipment?.ProductName,
                "RTO Charges": `${shipment?.rto_order_charge || 0}`,
                "Total Amount": `${shipment?.final_order_amount || 0}`,






            };
        });
    };
    const downloadExcel = () => {
        if (!orderData?.length) return;

        // Transform data
        const transformedData = transformDataForExport(orderData);

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "shipments.xlsx");
    };
    const handleDownloadInvoice = async (id, type) => {
        const GetOrderOrderDataValue = await GetOrderOrderData({
            variables: {
                "getOrderId": id,
            },
        });
        if (type === 'invoice') {
            setSingleOrder(GetOrderOrderDataValue?.data?.getOrder);
        } else {
            setSingleOrderLabel(GetOrderOrderDataValue?.data?.getOrder);
        }
    };
    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };
    const handleSort = (e) => {
        // setLoader(true);
        const type = sort.type == -1 ? 1 : -1;
        setSort({ key: e?.sortField, type });
    };


    useEffect(() => {
        if (singleOrder) {
            const invoiceElement = document.getElementById('invoice');
            if (!invoiceElement) return;

            invoiceElement.style.visibility = 'visible';
            invoiceElement.style.position = 'static';

            html2canvas(invoiceElement, { scale: 2 })
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF('p', 'mm', 'a4');
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    pdf.save(`invoice_${singleOrder?.order_id}.pdf`);

                    invoiceElement.style.visibility = 'hidden';
                    invoiceElement.style.position = 'absolute';
                })
                .catch((error) => console.error('Error generating PDF:', error));
        }
    }, [singleOrder]);

    useEffect(() => {
        if (singleOrderLabel) {
            setLoading(true);

            const invoiceElement = invoiceRef.current;
            if (!invoiceElement) {
                setLoading(false);
                return;
            }

            const doc = new jsPDF('p', 'pt', [288, 460]); // 4x6 inches

            // Render HTML content
            // doc.html(invoiceElement, {
            //     callback: function (doc) {
            //         doc.save(`label_${singleOrderLabel?.order_id}.pdf`);
            //     },
            //     autoPaging: false, // Ensures content doesn't spill onto a second page
            //     x: 0,
            //     y: 0,
            //     width: 288, // Match the container width
            //     windowWidth: 288, // Ensures proper scaling
            // })
            doc.html(invoiceElement, {
                callback: function (doc) {
                    // Add border after rendering the content
                    doc.setLineWidth(2); // Border thickness
                    doc.setDrawColor(15, 23, 42); // Border color in RGB (slate-900)
                    doc.rect(0, 0, 288, 460); // Draw rectangle covering the entire page

                    // Save the document
                    doc.save(`${singleOrderLabel?.pickupAddress?.name}_${singleOrderLabel?.order_id}_UK logistic.pdf`);
                },
                autoPaging: false, // Ensures content doesn't spill onto a second page
                x: 0,
                y: 0,
                width: 288, // Match the container width
                windowWidth: 288, // Ensures proper scaling
            })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [singleOrderLabel])
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };


    const resetData = () => {
        setPage(0);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedPaymentType('');
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown
        setActiveTab('All')
    }
    const onSelectedRowsChange = (data) => {
        // console.log('✌️data --->', data);
        if (data?.selectedCount > 0) {
            const Ids = data?.selectedRows?.map((d) => d)
            // console.log('✌️Ids --->', Ids);
            setMultipleId(Ids)
        } else {
            handleClear();
        }
    }




    const handleBulkLabelDownload = async () => {
        if (!multipleId || multipleId.length === 0) return;
        setLoading(true);

        // Create a jsPDF instance for orders that use the custom label
        const doc = new jsPDF("p", "pt", [288, 460]);
        let allowedLabelCount = 0;

        for (let i = 0; i < multipleId.length; i++) {
            const order = multipleId[i];
            if (!order) continue;

            if (allowedPincodes.includes(order?.pickupAddress?.zipCode)) {
                // Create a new temporary container for this order
                const container = document.createElement("div");
                container.style.position = "absolute";
                container.style.top = "-9999px";
                container.style.visibility = "visible";
                document.body.appendChild(container);

                // Use createRoot to render the CustomLabel component into the container
                const root = createRoot(container);
                root.render(<CustomLabel key={order.order_id} order={order} />);

                // Wait a moment to ensure the component fully renders
                await new Promise((resolve) => setTimeout(resolve, 500));

                // Use html2canvas to capture the container as an image
                await html2canvas(container, { scale: 2 }).then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");
                    const pdfWidth = doc.internal.pageSize.getWidth();
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                    // If this isn't the first allowed label, add a new page
                    if (allowedLabelCount > 0) {
                        doc.addPage();
                    }
                    doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                    allowedLabelCount++;
                });

                // Unmount the component and remove the container using the new API
                root.unmount();
                document.body.removeChild(container);
            } else {
                // For orders not in allowed pincodes, call handleDownload to trigger direct download
                handleDownload(order?.label, order?.Shipment_name);
            }
        }

        // If at least one order was processed using a custom label, save the bulk PDF
        if (allowedLabelCount > 0) {
            doc.save("bulk_labels.pdf");
        }
        setLoading(false);
        setMultipleId([]);
        handleClear();
    };


    return (
        <>
            <Header />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">

                        <h1 className="text-lg font-semibold text-gray-800">
                            All Shipment History
                        </h1>
                        <button
                            onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl" />
                            Export
                        </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                            // onKeyDown={handleSearch}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                // onKeyDown={() => handleSearch('awbNumber')}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Shipment IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { setFilterOrder(e.target.value); handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Shipment ID"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Payment Type</label>
                            <Select
                                options={typeOptions}
                                defaultValue={typeOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                        // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                        // paddingBottom: '-0.5px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                        color: '#A3AAB5',
                                        fontSize: '0.875rem',
                                    }),
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={warehouseOptions[0]}
                                className="w-full"
                                value={displayedDayRange} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRange(selectedOption?.value); // Update logical value
                                    setDisplayedDayRange(selectedOption); // Update displayed value
                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                        '&:hover': { borderColor: '#2b2b2b' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        zIndex: 1050,
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        zIndex: 1050,
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                        },
                                        zIndex: 1050,
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 1050,
                                        position: 'absolute',
                                    }),
                                }}
                            />
                        </div>


                        <div className="mt-6 flex gap-4">
                            <button className="bg-slate-500 text-white px-4 py-1 rounded-lg text-sm hover:bg-slate-600" onClick={resetData}>
                                Clear
                            </button>
                        </div>
                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Booked",
                            "Pending Pickup",
                            "In Transit",
                            "Out For Delivery",
                            "Delivered",
                            "RTO",
                            "RTO Delivered",
                            "Cancelled"
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="w-100 h-100">
                    <button
                        className="bg-blue-700 text-white py-2 px-4 rounded-lg my-4"
                        onClick={handleBulkLabelDownload}
                        disabled={loadingData || multipleId.length === 0}
                    >
                        {loadingData ? "Processing..." : "Print Bulk Labels"}
                    </button>
                    {/* {loader && <ComponentSpinner />} */}
                    <div>
                        <Table
                            columns={orderTableColumns}
                            data={orderData || []}
                            currentPage={page}
                            totalRecords={GetOrderOrder?.getOrders?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            handlePagination={handlePagination}
                            multiSelectRow={onSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                        />
                    </div>
                </div>

                <div id="hidden-invoice-container" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                    <Invoice order={singleOrder} />
                </div>
                <div id="label" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                    <CustomLabel ref={invoiceRef} order={singleOrderLabel} />
                </div>

            </div>
        </>
    )
}

export default AllOrderSeller
